import styled, { css } from 'styled-components';
import neutral from '../../themes/neutral/index.js';

var base = css(["&.sok-tag{height:auto;border-radius:24px;font-family:", ";display:inline-flex;align-items:center;margin-right:", ";&:focus{outline:0;box-shadow:0px 0px 0px 3px ", ";}&:not(.sok-tag-lg):not(.sok-tag-sm){line-height:", ";padding:", " ", ";font-size:", ";}&.sok-tag-lg{line-height:", ";padding:", " ", ";font-size:", ";}&.sok-tag-sm{line-height:", ";padding:0 ", ";font-size:", ";}}"], function (props) {
  return props.theme.tag.fonts.family;
}, neutral.spacings.xxSmall, function (props) {
  return props.theme.tag.focusColor;
}, function (props) {
  return props.theme.tag.lineHeight;
}, neutral.spacings.xxxSmall, neutral.spacings.small, function (props) {
  return props.theme.tag.fonts.sizeMiddle.fontSize;
}, function (props) {
  return props.theme.tag.lineHeight;
}, neutral.spacings.xxSmall, neutral.spacings.small, function (props) {
  return props.theme.tag.fonts.sizeLarge.fontSize;
}, function (props) {
  return props.theme.tag.lineHeight;
}, neutral.spacings.small, function (props) {
  return props.theme.tag.fonts.sizeSmall.fontSize;
});
var StyledTag = styled.span.withConfig({
  displayName: "Tagstyles__StyledTag",
  componentId: "sc-l4hmzp-0"
})(["", " &.sok-tag-closable{&:not(.sok-tag-disabled){cursor:pointer;}.close-icon{margin-left:", ";}}&.tag-default{&:not(.sok-tag-checkable){color:", ";background-color:", ";border:1px solid ", ";}&.sok-tag-disabled{background-color:", ";border:1px solid ", ";cursor:not-allowed;}&.sok-tag-closable{&:not(.sok-tag-disabled){&:hover{opacity:1;background-color:", ";border:1px solid ", ";}}}}&.tag-light{background-color:", ";color:", ";border:1px solid ", ";&[disabled],&[disabled]:hover{background-color:", ";color:", ";border:1px solid ", ";cursor:not-allowed;}&.sok-tag-closable{cursor:pointer;&:not(.sok-tag-disabled){&:hover{background-color:", ";color:", ";border:1px solid ", ";}}}}"], base, neutral.spacings.xxSmall, function (props) {
  return props.theme.tag.color;
}, function (props) {
  return props.theme.tag.backgroundColor;
}, function (props) {
  return props.theme.tag.backgroundColor;
}, function (props) {
  return props.theme.tag.disabledColor;
}, function (props) {
  return props.theme.tag.disabledColor;
}, function (props) {
  return props.theme.tag.hoverColor;
}, function (props) {
  return props.theme.tag.hoverColor;
}, function (props) {
  return props.theme.tag.light.backgroundColor;
}, function (props) {
  return props.theme.tag.light.textColor;
}, function (props) {
  return props.theme.tag.light.borderColor;
}, function (props) {
  return props.theme.tag.light.disabledBackgroundColor;
}, function (props) {
  return props.theme.tag.light.disabledColor;
}, function (props) {
  return props.theme.tag.light.disabledBackgroundColor;
}, function (props) {
  return props.theme.tag.light.hoverBackgroundColor;
}, function (props) {
  return props.theme.tag.light.textColor;
}, function (props) {
  return props.theme.tag.light.borderColor;
});
var StyledCheckableTag = styled.button.withConfig({
  displayName: "Tagstyles__StyledCheckableTag",
  componentId: "sc-l4hmzp-1"
})(["", " cursor:pointer;&.sok-tag-checkable.tag-primary{color:", ";background-color:", ";border:1px solid ", ";@media (hover:hover){&:not(.sok-tag-checkable-checked):hover{opacity:1;color:", ";border:1px solid ", ";}}&[disabled],&[disabled]:hover{color:", ";border:1px solid ", ";}}&.sok-tag-checkable.tag-default{color:", ";background-color:", ";border:1px solid transparent;@media (hover:hover){&:not(.sok-tag-checkable-checked):hover{opacity:1;color:", ";}}&[disabled],&[disabled]:hover{color:", ";}}&.sok-tag-checkable.tag-primary,&.sok-tag-checkable.tag-default{&.sok-tag-checkable-checked{color:", ";background-color:", ";border:1px solid ", ";@media (hover:hover){&:hover{opacity:1;background-color:", ";}}&[disabled],&[disabled]:hover{background-color:", ";border:1px solid ", ";color:", ";}}}"], base, function (props) {
  return props.theme.tag.backgroundColor;
}, function (props) {
  return props.theme.tag.color;
}, function (props) {
  return props.theme.tag.backgroundColor;
}, function (props) {
  return props.theme.tag.hoverColor;
}, function (props) {
  return props.theme.tag.hoverColor;
}, function (props) {
  return props.theme.tag.disabledColor;
}, function (props) {
  return props.theme.tag.disabledColor;
}, function (props) {
  return props.theme.tag.textColor;
}, function (props) {
  return props.theme.tag.defaultTagBackgroundColor;
}, function (props) {
  return props.theme.tag.hoverColor;
}, function (props) {
  return props.theme.tag.defaultDisabledTagColor;
}, function (props) {
  return props.theme.tag.color;
}, function (props) {
  return props.theme.tag.backgroundColor;
}, function (props) {
  return props.theme.tag.backgroundColor;
}, function (props) {
  return props.theme.tag.hoverColor;
}, function (props) {
  return props.theme.tag.disabledColor;
}, function (props) {
  return props.theme.tag.disabledColor;
}, function (props) {
  return props.theme.tag.color;
});

export { StyledCheckableTag, StyledTag };
//# sourceMappingURL=Tag.styles.js.map
